import React from 'react';
import {Link} from 'react-router-dom';
import API from '../../configAPI';
import PulseLoader from 'react-spinners/PulseLoader';
import CONFIG from '../../config';
import Moment from 'react-moment';
import 'moment-timezone';
class PostDetails extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            post : {
            },
            relations: [],
            loading: true
        }
    }
    componentDidMount(){
        this.getPost();
    }
    componentDidUpdate(prevProps){
        if(this.props.match.params.noticia !== prevProps.match.params.noticia){
            this.getPost();
        }
    }
    getPost = () =>{
        this.setState({
            loading: true
        });
        API.PRODUCTS(`post/${this.props.match.params.noticia}`)
        .then(resp =>{
            this.setState({
                post: resp.data.post,
                relations: resp.data.relations,
                loading: false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    render(){
        return (
            <div className="container-fluid mt-3 mb-3">
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row">
                        <section className="col xs-12 col-md-9">
                            <section className="col-12 d-flex justify-content-end mb-2">Compartir
                            <a href="#SharingModal" className="btn btn-secondary btn-sm mx-1" data-toggle="modal"><i className="fas fa-share-alt"></i></a>
                            <div className="modal" id="SharingModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                                <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalCenterTitle">Compartir</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="container-fluid">
                                    <div className="row d-flex flex-nowrap">                          
                                        <section className="col-md-3 text-center">
                                        <a  className="social face" 
                                            href={`https://www.facebook.com/sharer.php?u=${CONFIG.app_url +'noticia/'+ this.state.post.slug}`} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                        </section>
                                        <section className="col-md-3 text-center">
                                        <a  className="social tweet" 
                                            href={`https://twitter.com/intent/tweet?url=${CONFIG.app_url +'noticia/'+ this.state.post.slug}&text=${this.state.post.title}`} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                        </section>
                                        <section className="col-md-3 text-center">
                                        <a  className="social linked" 
                                            href={`https://www.linkedin.com/shareArticle?mini=true&url=${CONFIG.app_url +'noticia/'+ this.state.post.slug}`} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>
                                        </section>
                                    </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                                </div>
                                </div>
                            </div>
                            </div>
                        </section>
                            <img src={this.state.post.url_image} className="imagefull" alt="post"/>
                            <h3 className="mt-3">{this.state.post.title}</h3>
                            <p className="minitext"><strong>Publicado el <Moment format={'DD/MM/YYYY'}>{this.state.post.created_at}</Moment></strong></p>
                            <div dangerouslySetInnerHTML={{__html: this.state.post.body}}>
                                
                            </div>
                            <p><strong>Fuente: {this.state.post.fuente}</strong></p>
                        </section>

                        <div className="col-md-3">
                            <div className="col-12 mb-3"><h5>Temas que podrían interesarle</h5></div>
                            <section className="col-12 mb-4">
                                {this.state.relations.map((post,index) =>(
                                    <section key={index}>
                                        <div className="fila relativo">
                                            <Link to={`/noticia/${post.slug}`}> 
                                                <img src={post.url_image} className="img-fluid" alt="Hola"/>
                                                <div className="noticialink d-flex align-items-center p-2">
                                                    <div className="fila">
                                                    <section className="col-12 text-center">
                                                        <h2 className="noticiatitulo">{post.title}</h2>
                                                    </section>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="mt-3">
                                            <h6><strong>{post.title}</strong></h6>
                                            <p className="minitext">Publicado el <Moment format={'DD/MM/YYYY'}>{post.created_at}</Moment></p>
                                            <p>{post.description.substr(0,70)} ...</p>
                                        </div>
                                    </section>
                                ))}
                            
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default PostDetails;